// placingScoreTable.ts
export const placingScoreTable: Record<string, Record<string, number>> = {
  OW: {
    '1': 200,
    '2': 175,
    '3': 160,
    '4': 145,
    '5': 130,
    '6': 120,
    '7': 110,
    '8': 100,
    '9': 67,
    '10': 60,
    '11': 53,
    '12': 46,
    '13': 42,
    '14': 38,
    '15': 35,
    '16': 32,
  },
  DF: {
    '1': 125,
    '2': 105,
    '3': 95,
    '4': 85,
    '5': 75,
    '6': 67,
    '7': 60,
    '8': 53,
    '9': 35,
    '10': 28,
    '11': 24,
    '12': 21,
  },
  GW: {
    '1': 100,
    '2': 85,
    '3': 75,
    '4': 65,
    '5': 56,
    '6': 49,
    '7': 42,
    '8': 35,
    '9': 25,
    '10': 21,
    '11': 17,
    '12': 13,
  },
  GL: {
    '1': 80,
    '2': 65,
    '3': 55,
    '4': 46,
    '5': 39,
    '6': 35,
    '7': 31,
    '8': 28,
    '9': 21,
    '10': 17,
    '11': 14,
    '12': 11,
  },
  A: {
    '1': 56,
    '2': 49,
    '3': 42,
    '4': 35,
    '5': 31,
    '6': 27,
    '7': 24,
    '8': 21,
    '9': 15,
    '10': 13,
    '11': 11,
    '12': 9,
  },
  B: {
    '1': 42,
    '2': 35,
    '3': 31,
    '4': 27,
    '5': 24,
    '6': 21,
    '7': 18,
    '8': 15,
    '9': 13,
    '10': 11,
    '11': 9,
    '12': 8,
  },
  C: {
    '1': 32,
    '2': 27,
    '3': 22,
    '4': 18,
    '5': 15,
    '6': 13,
    '7': 12,
    '8': 11,
    '9': 10,
    '10': 9,
    '11': 8,
    '12': 7,
  },
  D: {
    '1': 21,
    '2': 15,
    '3': 13,
    '4': 11,
    '5': 10,
    '6': 9,
    '7': 8,
    '8': 7,
  },
  E: {
    '1': 14,
    '2': 10,
    '3': 7,
    '4': 6,
    '5': 5,
    '6': 4,
  },
  F: {
    '1': 7,
    '2': 4,
    '3': 2,
  },
};
